import * as React from 'react';
import RxorderFormView from '../layouts/RxOrderForm';
import { GetUserMessage, GetFileData, UserRxFormData } from 'src/reducers/rxForm';
import { UserDetail } from 'src/reducers/user';
import { RedesignReasons } from 'src/reducers/completeorderfile';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';

export interface RxOrderFormPageViewProps {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;

  userDetails: UserDetail;

  orderno: string;
  filename: string;
  filepath: string;
  feedback: string;
  createddate: string;
  duedate: string;
  lab: string;
  customerstatus: string;
  vfiles: string;
  status: string;
  caseNotes: string;
  tool_preferred: string;
  rxDetails: UserRxFormData[];
  designtype: string;
  destination: string;
  designername: string;
  fqcname: string;
  mdesignername: string;
  designapproval: string;
  modelonly: string;
  bravo: string;
  fdownload: string;
  qc_required: string;
  downloadedon: string;
  completedon: string;
  notations: string;
  product: string;
  model: string;
  getMessage: GetUserMessage[];
  customer: string;
  messages: string;
  refno: string;
  drpref: string;
  messaging: (message: string) => void;
  onSubmit: () => void;
  downloadFile: (filepath: string, filename: string, status: string, ociStatus: string, orderno: string) => void;
  onFeedback: () => void;
  onViewFeedback: () => void;
  onFilesChange: (messageFiles: Array<File>) => void;
  onFilesError: (error: Error, images: Array<File>) => void;
  getApiMessage: () => void;
  msgAtt: (msgAttachment: string, ociStatus: string) => void;
  getFilesData: GetFileData[];
  goStlViewer: (data: GetFileData[]) => void;

  getRxDetails: () => void;
  getFiles: () => void;
  getMessages: () => void;
  messageFiles: Array<File>;

  redesignReasons: RedesignReasons[];
  orderDataTat: TatData[];
  orderDataManufacturer: ManufacturerData[];
  redesignRequest: (columns: Object) => void;
  supportPage: (order: string) => void;

  openVideoPlayerURL: (fullPath: GetFileData[]) => void;
  openVideoPlayerURLArray: (fullPath: string[], fpath: string) => void;

  approvalRequired: (array: Array<object>) => void;

  verticalViewScreen: boolean;

  submitRework: (column: Object) => void;
}

class RxOrderFormPage extends React.Component<RxOrderFormPageViewProps> {
  render() {
    return (
      <div>
        <RxorderFormView
          userDetails={this.props.userDetails}
          orderno={this.props.orderno}
          filename={this.props.filename}
          filepath={this.props.filepath}
          feedback={this.props.feedback}
          createddate={this.props.createddate}
          destination={this.props.destination}
          designername={this.props.designername}
          fqcname={this.props.fqcname}
          mdesignername={this.props.mdesignername}
          designapproval={this.props.designapproval}
          modelonly={this.props.modelonly}
          bravo={this.props.bravo}
          fdownload={this.props.fdownload}
          qc_required={this.props.qc_required}
          downloadedon={this.props.downloadedon}
          completedon={this.props.completedon}
          duedate={this.props.duedate}
          lab={this.props.lab}
          customerstatus={this.props.customerstatus}
          vfiles={this.props.vfiles}
          status={this.props.status}
          caseNotes={this.props.caseNotes}
          tool_preferred={this.props.tool_preferred}
          onFeedback={this.props.onFeedback}
          onViewFeedback={this.props.onViewFeedback}
          rxDetails={this.props.rxDetails}
          designtype={this.props.designtype}
          downloadFile={this.props.downloadFile}
          notations={this.props.notations}
          product={this.props.product}
          model={this.props.model}
          getMessage={this.props.getMessage}
          customer={this.props.customer}
          messaging={this.props.messaging}
          onSubmit={this.props.onSubmit}
          messages={this.props.messages}
          onFilesChange={this.props.onFilesChange}
          onFilesError={this.props.onFilesError}
          getApiMessage={this.props.getApiMessage}
          msgAtt={this.props.msgAtt}
          getFilesData={this.props.getFilesData}
          goStlViewer={this.props.goStlViewer}
          getRxDetails={this.props.getRxDetails}
          getFiles={this.props.getFiles}
          getMessages={this.props.getMessages}
          messageFiles={this.props.messageFiles}
          redesignReasons={this.props.redesignReasons}
          orderDataTat={this.props.orderDataTat}
          orderDataManufacturer={this.props.orderDataManufacturer}
          redesignRequest={this.props.redesignRequest}
          supportPage={this.props.supportPage}
          openVideoPlayerURL={this.props.openVideoPlayerURL}
          openVideoPlayerURLArray={this.props.openVideoPlayerURLArray}
          approvalRequired={this.props.approvalRequired}
          verticalViewScreen={this.props.verticalViewScreen}
          submitRework={this.props.submitRework}
          refno={this.props.refno}
          drpref={this.props.drpref}
        />
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    // const url: string = window.location.href;
    this.props.onComponentWillMount();
  }
}

export default RxOrderFormPage;



// WEBPACK FOOTER //
// ./src/components/rxForm/RxFormPage.tsx